import { createAction } from '@reduxjs/toolkit'

export const ContractResetState = 'contract/resetState'
export const resetContractStates = createAction(ContractResetState)
